import React, { useState, useEffect, useRef } from 'react';
import { Container, Typography, Paper, CssBaseline, Box, TextField, Snackbar } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InputAdornment from '@mui/material/InputAdornment';

const UserSettings = () => {
  const containerRef = useRef(null);

  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [settings, setSettings] = useState({'api_key':'111111'});

  const fetchUserAPIKey = async () => {
    const response = await fetch('/api/user/apikey');
    const data = await response.json();
    console.log(data)
    if (data.error){
      window.location.href = '/';
      return;
    }else{ 
      setSettings(data);
    }
  }

  useEffect(() => {
    fetchUserAPIKey();
  }, []);

  const handleCopyApiKey = () => {
    setSnackbarOpen(false);
    navigator.clipboard.writeText(settings.api_key);
    setSnackbarOpen(true);
    setSnackbarMessage("API key copied to clipboard");
    setSeverity("success");
  };

  const handleCopyWifiPassword = () => {
    setSnackbarOpen(false);
    navigator.clipboard.writeText('abc12345');
    setSnackbarOpen(true);
    setSnackbarMessage("Default Wifi Password copied to clipboard");
    setSeverity("success");
  };

  const handleCopyWSSAddress = () => {
    setSnackbarOpen(false);
    navigator.clipboard.writeText('wss.beefuller.com');
    setSnackbarOpen(true);
    setSnackbarMessage("Default WSS Address copied to clipboard");
    setSeverity("success");
  };

  // 添加一个函数来处理API密钥的显示格式
  const formatApiKey = (key) => {
    if (!key) return '';
    return `${key.slice(0, 4)}${'*'.repeat(key.length - 4)}`;
  };

  return (
    <Container ref={containerRef}>
      <CssBaseline />
      <Box my={4} mx="auto" display="flex" flexDirection="column" justifyContent="center" alignItems="center" maxWidth={window.innerWidth > 1200 ? "60%" : "100%"}>
        <Typography variant="h4" style={{ marginBottom: '16px' }}>API KEY</Typography>
        
        <Paper elevation={3} sx={{ p: 3, width: '100%', mb: 2 }}>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              value={formatApiKey(settings.api_key)}
              InputProps={{
                readOnly: true,
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton onClick={handleCopyApiKey}>
                      <ContentCopyIcon />
                    </IconButton>
                  </InputAdornment>
              }}
            />
          </Box>
          <Typography variant="h6" gutterBottom>How to add new sensors</Typography>

          <Typography variant="h6" fontSize="15px" gutterBottom>
            1. Restart the sensor, SoftAP will be enabled with SSID of <b>BEE-MAC</b> and password of <b>Default Wifi Password</b>.<br/>
          </Typography>
          <Typography variant="h6" fontSize="15px" gutterBottom>
            2. You may configure SSID, password, wss, and apikey in the first 60 seconds after sensor boot up.
          </Typography>
          <Typography variant="h6" fontSize="15px" gutterBottom>
            3. Copy the above API key and paste it into the "API Key" field and set the "wss" to the server address to <b>Default WSS Address</b> which is the default server address.
          </Typography>
          <Typography variant="h6" fontSize="15px" gutterBottom>
            4. Click <b>update</b> button to save the configuration.
          </Typography>
          <Typography variant="h6" fontSize="15px" gutterBottom>
            Default Wifi Password: <b onClick={handleCopyWifiPassword}>abc12345 <IconButton size="small"><ContentCopyIcon /></IconButton></b>
          </Typography>
          <Typography variant="h6" fontSize="15px" gutterBottom>
            Default WSS Address: <b onClick={handleCopyWSSAddress}>wss.beefuller.com <IconButton size="small"><ContentCopyIcon /></IconButton></b>
          </Typography>
        </Paper>
      </Box>
      
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert  variant="filled" onClose={() => setSnackbarOpen(false)} severity={severity} sx={{ width: '100%' }}>{snackbarMessage}</Alert>
      </Snackbar>
    </Container>
  );
};

export default UserSettings;